module.exports = __webpack_public_path__ + "static/media/discord-banner.0b82d211.png";